<template>
    <div class="theme_common_bg_section">
        <div class="common_page_header">
            <button type="button" tapable="" class="btn btn-white-transparent back_btn"><i aria-hidden="true"
                    class="fa fa-chevron-left"></i></button> Workspace
        </div>
        <div class="common_page_body">
            <div class="row">
                <div class="col-sm-3">
                    <div class="quiz_icon_box">
                        <router-link :to="{name:'supportWorkspace'}">
                            <span class="quiz_icon">
                                <img src="@/assets/images/icon/support.png" class="img-fluid">
                            </span>
                            <span class="quiz_name">
                                Support
                            </span>
                        </router-link>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="quiz_icon_box">
                        <router-link :to="{name:'teamWorkspace'}">
                            <span class="quiz_icon">
                                <img src="@/assets/images/icon/team.png" class="img-fluid">
                            </span>
                            <span class="quiz_name">
                                Team
                            </span>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.theme_common_bg_section {
    background: rgba(0, 0, 0, 0.7);
    margin-bottom: 0;
    border-radius: 5px;
    min-height: calc(100vh - 96px);
    position: relative;
    overflow: hidden;

    .common_page_header {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        border-bottom: solid 1px rgba(228, 233, 237, 0.1);
        position: relative;
        font-family: 'MyriadProSemibold', 'Lato', sans-serif;
        font-weight: normal;
        font-size: 22px;
        padding: 10px 15px;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }

    .common_page_body{
        padding:15px;
        .quiz_icon_box {
                background: rgba(24, 24, 24, 0.7);
                transition: all ease 0.5s;
                -webkit-transition: all ease 0.5s;
                -moz-transition: all ease 0.5s;
                border: 1px solid #2c2b2b;
                border-radius: 5px;
                text-align: center;
                margin: 15px 0;
                cursor: pointer;

                &:hover {
                    background: #3be8b0;
                    color: #000000;

                    .quiz_name {
                        color: #000000;
                    }
                   .img-fluid {
                        filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(100deg) brightness(0%) contrast(100%);
                        -webkit-filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(100deg) brightness(0%) contrast(100%);
                    }

                }

                span {
                    display: block;
                    min-height: 65px;
                }

            .quiz_name {
                font-size: 22px;
                color: #fff;
                font-weight: 600;
                padding: 20px 0px;
                font-family: 'Beon';
            }
            a{text-decoration: none;padding: 60px 35px;display: block;}
        }
    }
}
</style>